import { http } from './config'
import authHeader from './auth-header';

export default {

    lista: (dataI, dataF, nomeEmpresa) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa
        }
        return http.get('/radar-dash/historico', {
           params: params,
           headers: authHeader()   
        })
    },


    historicoapp: (dataInicial, dataFinal, empresa) => {
        const params = {}
        if (dataInicial) params['dataInicial'] = dataInicial;
        if (dataFinal) params['dataFinal'] = dataFinal;
        if (empresa) params['empresa'] = empresa;
        return http.get('/radar-dash/consulta', {
           params: params,
           headers: authHeader()   
        })
    },


    importacao_periodo: (dataI, dataF, nomeEmpresa) => {
        
        const params= {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa
        }
        return http.get('/radar-dash/importacao-periodo', {
            params: params,
            headers: authHeader()
        })        
    },

    lancamento: (dataI, dataF, nomeEmpresa, documento) => {
        
        const params= {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'documento': documento
        }
        return http.get('/radar-dash/lancamento', {
            params: params,
            headers: authHeader()
        })        
    },

    baixa: (dataI, dataF, nomeEmpresa, documento, mongeral, cancelamento) => {
        
        const params= {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'documento': documento,
            'mongeral': mongeral,
            'cancelamento': cancelamento
        }
        return http.get('/radar-dash/baixa', {
            params: params,
            headers: authHeader()
        })        
    },

    verifica: (dataI, dataF, nomeEmpresa) => {
        
        const params= {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa
        }
        return http.get('/radar-dash/verifica', {
            params: params,
            headers: authHeader()
        })        
    },

    consultarBaixasPorDataEEmpresa: (dataBaixa, empresa) => {
        const params = {
            'dataBaixa': dataBaixa,
            'empresa': empresa
        }
        return http.get('/radar-dash/consultar-baixas-por-data-empresa', {
            params: params,
            headers: authHeader()
        })
    },

    totalBaixaTitulosIvertex: (dataInicial, dataFinal, empresa) => {
        const params = {
            'dataInicial': dataInicial,
            'dataFinal': dataFinal,
            'empresa': empresa
        }
        return http.get('/radar-dash/total-baixa-titulos-ivertex', {
            params: params,
            headers: authHeader()
        })
    },

    executarLancamentoTitulosPorRecebimentoData: (data, empresa) => {
        const params = {}
        if (data) params['data'] = data;
        if (empresa) params['empresa'] = empresa;
        return http.get('/radar-dash/executar-lancamento-titulos-por-recebimento-data', {
            params: params,
            headers: authHeader()
        })
    },
}
